import React, { useEffect, useState } from 'react';
import * as msal from '@azure/msal-browser';
import { useSelector } from 'react-redux';
import GnavAuthConfig from '../../app_config/gnavAuthConfig';
import AppConfig from '../../app_config/appConfig';
import './Gnav.scss';

const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
const gnavMSALObj = new msal.PublicClientApplication(GnavAuthConfig.msalConfig);

const Gnav = () => {
  const [gnavClass, setGnavClass] = useState('hideDiv');
  const [nognavClass, setNognavClass] = useState('hideDiv');
  const authStore = useSelector(state => state.authenticationData);

  const [modalVisible, setModalVisible] = useState(false);
const [modalVisibleRDP, setModalVisibleRDP] = useState(false);
  // Build and append script tag in header element
  const loadSingleScript = src => {
    return new Promise(function loadSingleScriptPromise(resolve, reject) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.addEventListener('load', resolve);
      script.addEventListener('error', reject);
      script.src = src;
      script.async = false;
      document.head.appendChild(script);
    });
  };

  // Process Script tags from AEM header response
  const processGnavHeader = gnavElement => {
    const parentElement = gnavElement;
    const childElements = parentElement.getElementsByTagName('script');
    for (let i = 0; i < childElements.length; i += 1) {
      const src = childElements[i].getAttribute('src');
      if (src) {
        try {
          loadSingleScript(src);
        } catch (ex) {
          // console.error(ex);
        }
      }
    }
  };

  function confirmPopup() {
    setModalVisible(prevState => !prevState);
    return modalVisible;
  }

  function confirmPopupRDP() {
    setModalVisibleRDP(prevState => !prevState);
    return modalVisibleRDP;
  }

  function outsideDEClickFunction(e) {
    if (window.location.hash.indexOf(AppConfig.routePaths.dataProduct) !== -1) {
      if (!confirmPopup()) {
        e.preventDefault();
        return false;
      }
    }
    return true;
  }

  function outsideDEClickFunctionRDP(e) {
    if (window.location.hash.indexOf(AppConfig.routePaths.registerDataProduct) !== -1) {
      if (!confirmPopupRDP()) {
        e.preventDefault();
        return false;
      }
    }
    return true;
  }

  // Get token using get access token method
  // Get head element from AEM endpoint
  const getGnavHeader = async () => {
    window.jqarray = [];

    const gnavAccessTokenVal = authStore.userDetails.gnavAccessToken;
    const encodedEmailId = encodeURIComponent(btoa(authStore.userDetails?.email.toLowerCase()));
    try {
      const gnavHeaderEndpointwithEmail = `${GnavAuthConfig.gnavHeaderEndpoint}.${encodedEmailId}.html`;
      const jsonResponse = await fetch(gnavHeaderEndpointwithEmail, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${gnavAccessTokenVal}`,
        },
      });
      const response = await jsonResponse;
      if (response.ok) {
        const data = await response.text();
        document.getElementById('gnav').innerHTML = data;
        const discoverLink = document
          .getElementById('gnav')
          .querySelector('.cmp-header-item-headerlink');
        const profileLink = document
          .getElementById('gnav')
          .querySelector('.cmp-header-item-profilelink');
        if (window.location.hash.indexOf(AppConfig.routePaths.dataProduct) !== -1) {
          discoverLink.onclick = outsideDEClickFunction;
          profileLink.onclick = outsideDEClickFunction;
        }
        if (window.location.hash.indexOf(AppConfig.routePaths.registerDataProduct) !== -1) {
          discoverLink.onclick = outsideDEClickFunctionRDP;
          profileLink.onclick = outsideDEClickFunctionRDP;
        }
        const gnavElement = document.createElement('div');
        gnavElement.innerHTML = data;
        await processGnavHeader(gnavElement);
        await delay(2000);
        setGnavClass('showDiv');
      } else {
        setNognavClass('showDiv');
      }
    } catch {
      setNognavClass('showDiv');
    }
  };

  // Get cached AEM header without using authorization token
  const getCachedGnavHeader = async () => {
    window.jqarray = [];
    const encodedEmailId = encodeURIComponent(btoa(authStore.userDetails?.email.toLowerCase()));
    const gnavHeaderEndpointwithEmail = `${GnavAuthConfig.gnavHeaderEndpoint}.${encodedEmailId}.html`;
    try {
      const jsonResponse = await fetch(gnavHeaderEndpointwithEmail, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const Response = await jsonResponse;
      if (Response.ok) {
        const data = await Response.text();
        document.getElementById('gnav').innerHTML = data;
        const discoverLink = document
          .getElementById('gnav')
          .querySelector('.cmp-header-item-headerlink');
        const profileLink = document
          .getElementById('gnav')
          .querySelector('.cmp-header-item-profilelink');
        if (window.location.hash.indexOf(AppConfig.routePaths.dataProduct) !== -1) {
          discoverLink.onclick = outsideDEClickFunction;
          profileLink.onclick = outsideDEClickFunction;
        }
        if (window.location.hash.indexOf(AppConfig.routePaths.registerDataProduct) !== -1) {
          discoverLink.onclick = outsideDEClickFunctionRDP;
          profileLink.onclick = outsideDEClickFunctionRDP;
        }
        const gnavElement = document.createElement('div');

        gnavElement.innerHTML = data;
        await processGnavHeader(gnavElement);
        await delay(2000);
        setGnavClass('showDiv');
      } else {
        await getGnavHeader();
      }
    } catch {
      setNognavClass('showDiv');
    }
  };

  // Get AEM header to be used as the GNAV header
  useEffect(async () => {
    if (authStore.isAuthenticated && authStore.userDetails?.email) {
      // const currentUserEmailId = authStore.userDetails?.email.toLowerCase();

      // await authorize.getTokenAcquireAsync();
      await gnavMSALObj
        .handleRedirectPromise()
        .then(getCachedGnavHeader())
        .catch(() => {
          // console.error(err);
        });
    }
  }, [authStore.isAuthenticated]);

  return (
    <>
      <div>
        <div id="nognav" className={nognavClass}>
          Sorry Navigation is not available now
        </div>
        <div id="gnav" className={gnavClass} />
      </div>

    </>
  );
};

export default Gnav;
